import api from "@/api/api-v1-config";

export async function getJournalEntryLineAxios() {    
    return await api.get("v1/journalentrylines/journalentryline");
}

export async function getJournalEntryLineIDAxios(id) {    
    return await api.get("v1/journalentrylines/Id="+ id);
}

export async function deleteJournalEntryLineAxios(id) {    
    return await api.delete("v1/journalentrylines/" + id);
}

export async function postJournalEntryLineAxios(journalentryline) {    
    return await api.post("v1/journalentrylines/journalentryline", journalentryline);
}

export async function postJournalEntryLinesAxios(journalentryline) {    
    return await api.post("v1/journalentrylines/journalentrylines", journalentryline);
}

export async function putJournalEntryLineAxios(journalentryline) {    
    return await api.put("v1/journalentrylines/", journalentryline);
}

